// 分析自動実行（media-analysis-automation）
export const MediaAnalysisAutomationApiPath = {
  LIST_SCHEDULES: '/api/sites/{site_id}/media-analysis-automation', // GET List Schedules
  UPSERT_SCHEDULE: '/api/sites/{site_id}/media-analysis-automation/{analysis_type}' // PUT Upsert Schedule
}

export type MediaAnalysisAutomationApiPath =
  (typeof MediaAnalysisAutomationApiPath)[keyof typeof MediaAnalysisAutomationApiPath]

export type ScheduleFrequency = 'daily' | 'weekly' | 'monthly'

export interface ScheduleItem {
  key: string
  label: string
  requires_target: boolean
  is_geo_llmo: boolean
  enabled: boolean
  frequency: ScheduleFrequency | null
  weekdays: string[]
  day_of_month: number | null
  hour: number | null
  minute: number | null
  target_id: number | null
  target_name: string | null
  frequency_label: string | null
  next_run_at: string | null
  last_run_at: string | null
  last_run_status: string | null
  last_run_history_id: number | null
  last_run_error: string | null
  updated_at: string | null
}

export interface ListSchedulesVars {
  site_id: number
}

export interface ListSchedulesResponse {
  items: ScheduleItem[]
}

export interface UpsertScheduleVars {
  site_id: number
  analysis_type: string
  enabled: boolean
  frequency?: ScheduleFrequency | null
  weekdays?: string[] | null
  day_of_month?: number | null
  hour?: number | null
  minute?: number | null
  target_id?: number | null
}

export interface UpsertScheduleResponse {
  ok: boolean
  id: number
}
